import ServiceApi from "./service";
import UI from "../shared/Components/UI/js";

class ConfigurationsApi {
    async getChatConfiguration () {
        const response = await ServiceApi.get(`doctors_onboarding/chat/configuration`, null);

        if (response?.status === 200) {
            const data = UI.extract_data(response);
            // data.data = mapPatients(data.data
            data.status = 200;
            return data;
        } else {
            return {
                status: response?.status || "",
                data: response?.data?.d || null,
                message: response?.data?.m || ""
            }
        }
    }
}

export default new ConfigurationsApi()
